export const PRODUCT_UNITS = [
  { value: 'pcs', label: 'Pieces (pcs)' },
  // { value: 'meter', label: 'Meter (meter)' },
  // { value: 'centimeter', label: 'Centimeter (centimeter)' },
  { value: 'm', label: 'Meter (m)' },
  { value: 'cm', label: 'Centimeter (cm)' },
  { value: 'mm', label: 'Millimeter (mm)' },
  { value: 'box', label: 'Box' },
  { value: 'pack', label: 'Pack' },
  { value: 'kg', label: 'Kilogram (kg)' },
  { value: 'g', label: 'Gram (g)' },
  { value: 'litre', label: 'Litre (L)' },
  { value: 'ml', label: 'Millilitre (mL)' },
  { value: 'feet', label: 'Feet (ft)' },
  { value: 'inch', label: 'Inch (in)' },
  { value: 'yard', label: 'Yard (yd)' },
  { value: 'sqm', label: 'Square Meter (sqm)' },
  { value: 'sqft', label: 'Square Feet (sqft)' },
  { value: 'roll', label: 'Roll' },
  { value: 'bundle', label: 'Bundle' },
  { value: 'set', label: 'Set' },
  { value: 'pair', label: 'Pair' },
  { value: 'dozen', label: 'Dozen' },
  { value: 'carton', label: 'Carton' },
  { value: 'drum', label: 'Drum' },
  { value: 'can', label: 'Can' },
  { value: 'bottle', label: 'Bottle' },
  { value: 'bag', label: 'Bag' },
];
